import Vue from "vue";
import VueResource from "vue-resource";
import Icon from "vue-awesome/components/Icon";

import i18n from "./messages/i18n";
import router from "./router";
import store from "./store";

import App from "./App.vue";
import "./registerServiceWorker";

Vue.config.productionTip = false;

// globally include v-icon component for Font Awesome icons
Vue.component("v-icon", Icon);

// global directives
Vue.directive("click-outside", {
  bind: function(el, binding, vnode) {
    el.clickOutsideEvent = function(event) {
      if (!(el === event.target || el.contains(event.target))) {
        // and if it did, call method provided in attribute value
        vnode.context[binding.expression](event);
      }
    };
    document.body.addEventListener("click", el.clickOutsideEvent);
  },
  unbind: function(el) {
    document.body.removeEventListener("click", el.clickOutsideEvent);
  }
});

Vue.use(VueResource);
Vue.http.headers.common["Content-Type"] = "application/json";

// attach the whole APP as global variable for easier debugging
// TODO: remove this in production
window.SPAJZA = new Vue({
  render: h => h(App),
  router,
  store,
  i18n
}).$mount("#app");
